// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3JE5T","modalForm":"UpgradeEpcsModal_modalForm__19wyk","modalFooter":"UpgradeEpcsModal_modalFooter__2Xn62"};